import React, { useEffect } from "react";

const WarningModal = ({ isOpen, setIsOpen, onConfirm }) => {
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      toggleModal();
    }
  };

  // Focus on the modal when it opens
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable background scroll
      document.getElementById("confirmButton").focus();
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.style.overflow = "unset"; // Enable background scroll
      window.removeEventListener("keydown", handleKeyDown);
    }

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          id="popup-modal"
          tabIndex="-1"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-[2px]"
        >
          <div className="relative max-h-full w-full max-w-md p-6">
            <div className="relative rounded-lg bg-white shadow-lg dark:bg-gray-700">
              {/* Close button */}
              <button
                type="button"
                onClick={toggleModal}
                className="absolute right-3 top-3 ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-gray-400 hover:bg-gray-200 hover:text-gray-900 focus:outline-none dark:hover:bg-gray-600 dark:hover:text-white"
                aria-label="Close modal"
              >
                <svg
                  className="h-5 w-5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 4l12 12m0-12L4 16"
                  />
                </svg>
              </button>

              <div className="p-6 text-center">
                {/* Warning icon */}
                <svg
                  className="mx-auto mb-4 h-12 w-12 text-red-600 dark:text-gray-200"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <h3 className="mb-5 text-lg font-semibold text-red-600 dark:text-gray-400">
                  Are you sure you want to delete this product?
                </h3>

                {/* Confirmation button */}
                <button
                  id="confirmButton"
                  onClick={() => {
                    setIsOpen(false);
                    onConfirm();
                  }}
                  className="inline-flex items-center rounded-lg bg-red-600 px-5 py-2.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300 dark:focus:ring-red-800"
                >
                  Yes, I'm sure
                </button>

                {/* Cancel button */}
                <button
                  onClick={toggleModal}
                  className="ms-3 mt-3 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 transition-colors duration-200 hover:bg-gray-100 hover:text-blue-700 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-700"
                >
                  No, cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WarningModal;
